import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import * as PropTypes from "prop-types";
import pin from "../../img/pin.svg"
import _ from "../../utils/ObjectUtils";

class GoogleMap extends Component {
    static defaultProps = {
        zoom: 8
    };

    render() {
        const {lat, lng, zoom} = this.props;

        return (
            // Important! Always set the container height explicitly
            <div style={{ height: '44vh', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyDpW7q3rF2mko0CNtNT13hlRo4yKImw4EU" }}
                    defaultCenter={{
                        lat: lat,
                        lng: lng
                    }}
                    defaultZoom={zoom}
                    onGoogleApiLoaded={({map, maps}) => addMarkers(lat, lng, map, maps)}
                />
            </div>
        );
    }
}

function addMarkers(lat, lng, map, maps) {
    const markers = [{
        position: {"lat":lat, "lng":lng},
        icon: {
            url: pin,
        },
        zIndex: 0,
        key: 1,
        title: "Pin"
    }];

    if (markers) {
        if (!_.isEmpty(map) && !_.isEmpty(maps)) {
            return markers.map((marker) => {
                marker.icon = {
                    ...marker.icon,
                    scaledSize: maps.Size(28, 32),
                    origin: maps.Point(0, 0)
                };

                let markerItem = new maps.Marker({
                    ...marker,
                    map: map
                });

                return markerItem;
            });
        }
    }
}

GoogleMap.propTypes = {
    lng : PropTypes.number,
    lat : PropTypes.number,
    zoom : PropTypes.number
};

export default GoogleMap;